import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
import querystring from 'querystring'

const voucherApi = {
  list (params) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/vouchers/`,
      {params: params})
  },
  detail (voucherId, params) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/vouchers/${voucherId}/`,
      {params: params})
  },
  create (params) {
    // 创建新主题
    // return axios.post(
    //   `${ApiSetting.baseUrl}/api/vouchers/`, querystring.stringify(params))
    return axios.post(
      `${ApiSetting.baseUrl}/api/vouchers/`, querystring.stringify(params))
  },
  update (voucherId, params) {
    // 更新主题
    // return axios.post(
    //   `${ApiSetting.baseUrl}/api/vouchers/`, querystring.stringify(params))
    return axios.put(
      `${ApiSetting.baseUrl}/api/vouchers/${voucherId}/`, querystring.stringify(params))
  },
  delete (voucherId) {
    window.console.log("发起删除请求")
    return axios.delete(
      `${ApiSetting.baseUrl}/api/vouchers/${voucherId}/`
    )
  }
}

export default voucherApi
